export const knownLanguages = () => {
    return [
        { name: 'English', code: 'en-US' },
        { name: 'Français', code: 'fr' },
        { name: 'Italiano', code: 'it' },
        { name: 'Deutsch', code: 'de-DE' },
        { name: 'Melayu', code: 'ms-MY' },
        { name: 'Suomi', code: 'fi' },
        { name: 'Español', code: 'es-ES' },
        { name: 'Português', code: 'pt-PT' },
        { name: 'Nederlands (Be)', code: 'nl-BE' },
        { name: 'हिन्दी', code: 'hi-IN' },
        { name: 'Polski', code: 'pl-PL' },
        { name: 'Magyar', code: 'hu-HU' },
        { name: 'Ελληνικά', code: 'el-GR' },
        { name: 'Română', code: 'ro-RO' },
        { name: 'Tiếng Việt', code: 'vi-VN' },
        { name: 'Bahasa Indonesia', code: 'id-ID' },
        { name: 'ไทย', code: 'th-TH' },
        { name: '中文', code: 'zh-CN' },
    ];
}

export const setLang = async (code, { changeFn, onComplete }) => {
    await changeFn(code);
    localStorage.setItem('lang', code);
    if (onComplete) onComplete();
};

export const mapLang = (lang) => {
    const DEFAULT_LANG = 'en-US';
    if (!lang) return DEFAULT_LANG;
    const langCode = lang.toLowerCase().substring(0, 2);
    const matchingLang = knownLanguages().find(l => l.code.toLowerCase().startsWith(langCode));
    return matchingLang ? matchingLang.code : DEFAULT_LANG;
};